import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const notificationMarkAllAsReadMutationAtom = createMutationAtomFactory(
  'notifications.markAllAsRead',
  () => ({
    notificationMarkAllAsRead: {
      __args: {
        channel: 'in_app' as const,
      },
    },
  }),
);
